<ion-content class="background">
  <div [ngClass]="{'ios-space-top': platform.is('ios')}"></div>
  <div class="sub-title-2">
    <ion-label>Datos de retiro de muestra</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >País:
              <span class="t-bold">{{currentGather.country_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >{{ "Provincia" | translate }}:
              <span class="t-bold">{{currentGather.state_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >{{"Localidad" | translate }}:
              <span class="t-bold">{{currentGather.city_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Instituto:
              <span class="t-bold">{{currentGather.institution_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">Dirección: <span class="t-bold">{{currentGather.address}} </span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="currentGather.postal.length > 1">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">Cod. Postal: <span class="t-bold">{{currentGather.postal}}</span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Persona Contacto: <span class="t-bold">{{currentGather.contact_info.name_contact}} </span></ion-label
            >
          </ion-label>
        </ion-item>

        <!-- <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Prefijo:
              <span class="t-bold">{{currentGather.contact_info.prefix}} </span>
            </ion-label>
          </ion-label>
        </ion-item> -->

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Teléfono Contacto:
              <span class="t-bold">
                ({{currentGather.contact_info.prefix}}) - {{currentGather.contact_info.phone}}
              </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="currentGather.observation.length > 1">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Observaciones:
              <span class="t-bold">{{currentGather.observation}} </span>
            </ion-label>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label
      >Datos de la{{currentGather.gatherDetail.length > 1?"s":""}} Muestra{{currentGather.gatherDetail.length >
      1?"s":""}}</ion-label
    >
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <div *ngFor="let item of currentGather.gatherDetail; let i = index">
          <div *ngFor="let study of currentGather.gatherDetail">
            <ion-item lines="none" class="ion-no-padding">
              <ion-label color="tertiary">
                <ion-label color="tertiary">
                  Tipo de estudio:
                  <span class="t-bold"> {{study.name}} </span>
                </ion-label>
              </ion-label>
            </ion-item>

            <ion-item lines="none" *ngIf="study.count_gather !=''">
              <ion-label color="tertiary">
                <ion-label color="tertiary">
                  Nro. de Muestras:
                  <span class="t-bold"> {{study.count_gather}} </span>
                </ion-label>
              </ion-label>
            </ion-item>

            <ion-item lines="none" class="ion-no-padding" *ngIf="currentGather.urgency !=''">
              <ion-label color="tertiary">
                <ion-label color="tertiary">
                  Urgencia:
                  <span class="t-bold"> {{currentGather.urgency}} </span>
                </ion-label>
              </ion-label>
            </ion-item>

            <ion-item lines="none" class="ion-no-padding" *ngIf="currentGather.temperature !=''">
              <ion-label color="tertiary">
                <ion-label color="tertiary">
                  Temperatura:
                  <span class="t-bold"> {{currentGather.temperature}} </span>
                </ion-label>
              </ion-label>
            </ion-item>

            <ion-item lines="none" class="ion-no-padding" *ngIf="currentGather.comments !=''">
              <ion-label color="tertiary">
                <ion-label color="tertiary">
                  Comentarios:
                  <span class="t-bold"> {{currentGather.comments}} </span>
                </ion-label>
              </ion-label>
            </ion-item>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label>Horarios de Atención</ion-label>
  </div>

  <ion-grid class="content-resume">
    <div *ngIf="currentGather.horary && currentGather.horary.length > 0 && hasValidDates()">
      <ion-row class="pickup-date-target">
        <ng-container *ngFor="let horario of currentGather.horary">
          <ion-col *ngIf="isValidDate(horario.date)" size="12" class="pickup-date">
            <div>
              <ion-label>
                Fecha de recogida: <b>{{formatDate(horario.date)}}</b>
              </ion-label>
            </div>
            <div>
              <ion-label>
                Hora de inicio: <b>{{horario.first_hour}}</b>
              </ion-label>
            </div>
            <div>
              <ion-label>
                Hora de fin: <b>{{horario.last_hour}}</b>
              </ion-label>
            </div>
          </ion-col>
        </ng-container>
      </ion-row>
    </div>
    
    <div *ngIf="currentGather.horary && currentGather.horary.length > 0 && !currentGather.horary[0].date" class="pickup-date-target">
      <ion-col size="12" style="display: block;" class="pickup-date">
        <div>
          <ion-label>
            Fecha de recogida: <b>Lunes a Viernes 9:00 a 15:00 (Sin fecha específica registrada)</b>
          </ion-label>
        </div>
      </ion-col>
    </div>

    <div *ngIf="!currentGather.horary || currentGather.horary.length === 0" class="no-schedules">
      <ion-text color="medium">No hay horarios programados</ion-text>
    </div>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label>Información de Rastreo</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ng-container *ngFor="let item of currentGather.events">
          <div>
            <ion-item lines="none" class="t-ce text-label" *ngIf="item.date_exec && item.date_exec.length > 0">
              <ion-label color="tertiary" class="t-ce text-label t-bold">
                <span>{{item.date_exec}}</span>

                &nbsp;&nbsp;&nbsp;&nbsp;
                <span>{{item.event_name}}</span>
                <br />
                <span>{{item.observation}}</span>
              </ion-label>
            </ion-item>
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Input Botones -->
  <ion-grid>
    <ion-row style="margin-top: 1rem !important">
      <ion-col class="ion-text-center btn-message" size="12">
        <app-btn-support [message]="messageSupport"></app-btn-support>
      </ion-col>

      <ion-col class="ion-text-center" size="12">
        <button (click)="closeModal()" id="btn-close-modal" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
